import React, { useState, useEffect } from "react";
import BotonManualHeader from "../../components/BotonManualHeader";
import firebaseApp from "../../firebase/credenciales";
import {
  Container,
  Card,
  Form,
  Button,
  Table,
  Spinner,
  ProgressBar,
  Row,
  Col,
  Badge,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { FaUpload, FaFileAlt, FaCloudUploadAlt, FaChartLine } from "react-icons/fa";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import {
  addDoc,
  collection,
  getDocs,
  getFirestore,
  query,
  where,
  serverTimestamp,
  doc,
  getDoc,
  setDoc,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";

import sendCustomEmail from "../../functions/sendCustomEmail";
import { sendNotificationBatch } from "../../functions/sendNotification";
import { BsCheckCircleFill, BsFillXCircleFill } from "react-icons/bs";
import { MdVisibility, MdVisibilityOff } from "react-icons/md";
import { TbDatabase, TbDatabaseOff } from "react-icons/tb";
import Swal from "sweetalert2";
import { logBusinessAction } from "../../services/AuditService";

// MODIFICACIÓN: función local para añadir documento usando addDoc
async function añadirDocumento(infoDocumento) {
  const db = getFirestore(firebaseApp);
  const docRef = await addDoc(collection(db, "document"), infoDocumento);
  return docRef.id;
}

const Masivos = ({ usuario }) => {
  const db = getFirestore(firebaseApp);
  const auth = getAuth(firebaseApp);
  const storage = getStorage(firebaseApp);

  // Estado para datos de empresa
  const [empresa, setEmpresa] = useState({
    ruc: "",
    name: "",
    coleccionEmail: "mailTurbo",
    notificaciones: false,
    actividad: "",
    direccion: "",
    nombreComercial: "",
    trabajadores: "",
  });

  const [archivos, setArchivos] = useState([]);
  const [documentos, setDocumentos] = useState([]);
  const [tipoDoc, setTipoDoc] = useState("DEFAULT");
  const [isDisabledButton, setIsDisabledButton] = useState(false);
  const [periodicidad, setPeriodicidad] = useState("DEFAULT");
  const [mes, setMes] = useState("DEFAULT");
  const [progresoGlobal, setProgresoGlobal] = useState(0);

  // Metadatos para PDF
  const metadata = { contentType: "application/pdf" };

  // Obtener datos de empresa al montar el componente (solo una vez)
  useEffect(() => {
    async function fetchEmpresa() {
      if (usuario?.ruc) {
        const docRef = doc(db, "company", usuario.ruc);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          console.log("Datos de empresa:", data);
          setEmpresa({
            ruc: data.ruc || "",
            name: data.name || "",
            coleccionEmail:
              data.coleccionEmail && data.coleccionEmail.trim() !== ""
                ? data.coleccionEmail
                : "mailTurbo",
            notificaciones: data.notificaciones === true,
            actividad: data.actividad || "",
            direccion: data.direccion || "",
            nombreComercial: data.nombreComercial || "",
            trabajadores: data.trabajadores || "",
          });
        } else {
          // Si no existe, usa valores por defecto
          setEmpresa({
            ruc: usuario.ruc || "",
            name: usuario.name || "",
            coleccionEmail: "mailTurbo",
            notificaciones: false,
            actividad: "",
            direccion: "",
            nombreComercial: "",
            trabajadores: "",
          });
          Swal.fire({
            icon: "error",
            title: "No se encontró información de la empresa",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      }
    }
    fetchEmpresa();
    // eslint-disable-next-line
  }, [usuario, db]);

  const handlePeriodoChange = (event) => {
    setPeriodicidad(event.target.value);
    if (event.target.value === "mensual") setMes(null);
    else if (event.target.value === "semanal") setMes("DEFAULT");
  };

  const handleMesChange = (event) => setMes(event.target.value);

  const handleChange = (e) => {
    for (let i = 0; i < e.target.files.length; i++) {
      const newDocumento = e.target.files[i];
      newDocumento["id"] = Math.random();
      setDocumentos((prevState) => [...prevState, newDocumento]);
    }
  };

  const selectChange = (e) => setTipoDoc(e.target.value);

  function isNumber(numero) {
    return Number.isInteger(numero);
  }

  function periodo(mes) {
    switch (mes) {
      case "01":
        return "ENERO";
      case "02":
        return "FEBRERO";
      case "03":
        return "MARZO";
      case "04":
        return "ABRIL";
      case "05":
        return "MAYO";
      case "06":
        return "JUNIO";
      case "07":
        return "JULIO";
      case "08":
        return "AGOSTO";
      case "09":
        return "SETIEMBRE";
      case "10":
        return "OCTUBRE";
      case "11":
        return "NOVIEMBRE";
      case "12":
        return "DICIEMBRE";
      default:
        return "";
    }
  }

  function tipoDocumento(tipo) {
    switch (tipo) {
      case "Boletas de pago":
        return "BOLETA DE PAGO";
      case "CTS":
        return "CTS";
      case "Gratificaciones":
        return "GRATIFICACIÓN";
      case "Utilidades":
        return "LIQUIDACIÓN DE UTILIDADES";
      case "Contratos":
        return "CONTRATOS";
      case "Renta":
        return "RENTA DE 5TA CATEGORIA";
      case "Memorandums":
        return "MEMORANDUMS";
      case "Vacaciones":
        return "VACACIONES";
      case "Prestamos":
        return "PRESTAMO";
      case "Adelantos":
        return "ADELANTO";
      case "PoliticasLaborales":
        return "POLITICA SALARIAL";
      case "Ceses":
        return "CESES Y LIQUIDACIONES";
      case "Otros":
        return "OTROS";
      default:
        return "";
    }
  }

  function erroVerificarNombre() {
    Swal.fire({
      position: "top-end",
      icon: "error",
      title: "Error con el nombre del archivo",
      showConfirmButton: false,
      timer: 1500,
    });
  }

  function finalizarProceso() {
    Swal.fire({
      position: "top-end",
      icon: "success",
      title: "Proceso finalizado, por favor revise el reporte generado",
      showConfirmButton: false,
      timer: 1500,
    });
  }

  async function crearDocumentoComunicacionAgent(dni) {
    const q = query(collection(db, "users"), where("dni", "==", dni));
    const querySnapshot = await getDocs(q);
    let userId = null;
    querySnapshot.forEach((docu) => {
      userId = docu.id;
    });
    if (userId) {
      const notifDocRef = doc(
        db,
        "users",
        userId,
        "notifications",
        "comunication-agent"
      );
      await setDoc(
        notifDocRef,
        { createdAt: serverTimestamp() },
        { merge: true }
      );
    }
  }

  // Procesa un solo documento (subida, registro, notificación, correo)

  
  // REEMPLAZAR la función isNumber para DNI con esta nueva función
  function isValidDNI(dni) {
    // DNI debe ser una cadena de 8 o 9 dígitos (puede empezar con ceros)
    return /^\d{8,9}$/.test(dni);
  }
  
  // MODIFICAR la función procesarDocumento
  async function procesarDocumento(documento, index, total, empresaData) {
    let nombreArchivo = documento.name;
    let largo = nombreArchivo.length;
    let dni, ano, mesArchivo, semana = "";
  
    // --- Parsing de nombre de archivo ---
  if (largo === 20) {
    // Verificar si es formato con 8 o 9 dígitos
    if (nombreArchivo.match(/^\d{8}_\d{6}\.pdf$/)) {
      dni = nombreArchivo.substr(0, 8);
      ano = nombreArchivo.substr(9, 4);
      const sufijo = nombreArchivo.substr(13, 2);
      if (periodicidad === "mensual") {
        mesArchivo = sufijo;
        semana = "";
      } else if (periodicidad === "semanal") {
        semana = "SEM" + sufijo;
        mesArchivo = mes;
      }
    } else if (nombreArchivo.match(/^\d{9}_\d{6}\.pdf$/)) {
      dni = nombreArchivo.substr(0, 9);
      ano = nombreArchivo.substr(10, 4);
      const sufijo = nombreArchivo.substr(14, 2);
      if (periodicidad === "mensual") {
        mesArchivo = sufijo;
        semana = "";
      } else if (periodicidad === "semanal") {
        semana = "SEM" + sufijo;
        mesArchivo = mes;
      }
    } else {
      // Formato antiguo sin guión bajo
      dni = nombreArchivo.substr(0, 8);
      ano = nombreArchivo.substr(12, 4);
      mesArchivo = nombreArchivo.substr(9, 2);
    }
  } else if (largo === 21) {
    // Verificar si es formato con guión bajo o formato antiguo
    if (nombreArchivo.match(/^\d{9}_\d{6}\.pdf$/)) {
      dni = nombreArchivo.substr(0, 9);
      ano = nombreArchivo.substr(10, 4);
      const sufijo = nombreArchivo.substr(14, 2);
      if (periodicidad === "mensual") {
        mesArchivo = sufijo;
        semana = "";
      } else if (periodicidad === "semanal") {
        semana = "SEM" + sufijo;
        mesArchivo = mes;
      }
    } else {
      // Formato antiguo
      dni = nombreArchivo.substr(0, 9);
      ano = nombreArchivo.substr(13, 4);
      mesArchivo = nombreArchivo.substr(10, 2);
    }
  } else if (largo === 26) {
    dni = nombreArchivo.substr(0, 8);
    mesArchivo = nombreArchivo.substr(9, 2);
    ano = nombreArchivo.substr(12, 4);
    semana = nombreArchivo.substr(17, 5);
  } else if (largo === 27) {
    dni = nombreArchivo.substr(0, 9);
    mesArchivo = nombreArchivo.substr(10, 2);
    ano = nombreArchivo.substr(13, 4);
    semana = nombreArchivo.substr(18, 5);
  } else if (
    largo === 29 &&
    nombreArchivo.match(/^\d{8}[A-Z]{3}\d{4}\d{2}\d{8}\.pdf$/)
  ) {
    const ceros = nombreArchivo.substr(0, 8);
    const tipo = nombreArchivo.substr(8, 3);
    ano = nombreArchivo.substr(11, 4);
    mesArchivo = nombreArchivo.substr(15, 2);
    dni = nombreArchivo.substr(17, 8);
  } else if (
    largo === 30 &&
    nombreArchivo.match(/^\d{8}[A-Z]{3}\d{4}\d{2}\d{9}\.pdf$/)
  ) {
    const ceros = nombreArchivo.substr(0, 8);
    const tipo = nombreArchivo.substr(8, 3);
    ano = nombreArchivo.substr(11, 4);
    mesArchivo = nombreArchivo.substr(15, 2);
    dni = nombreArchivo.substr(17, 9);
  } else if (largo === 19 && nombreArchivo.match(/^\d{8}_\d{6}\.pdf$/)) {
    dni = nombreArchivo.substr(0, 8);
    ano = nombreArchivo.substr(9, 4);
    const sufijo = nombreArchivo.substr(13, 2);
    if (periodicidad === "mensual") {
      mesArchivo = sufijo;
      semana = "";
    } else if (periodicidad === "semanal") {
      semana = "SEM" + sufijo;
      mesArchivo = mes;
    }
  }

  let semanaNumero =
    semana && semana.startsWith("SEM")
      ? parseInt(semana.replace("SEM", ""))
      : parseInt(semana);

  // CAMBIAR la validación principal
  if (
    isValidDNI(dni) &&
    isNumber(parseInt(ano)) &&
    ano > 2020 &&
    ((periodicidad === "mensual" &&
      isNumber(parseInt(mesArchivo)) &&
      mesArchivo <= 12) ||
      (periodicidad === "semanal" &&
        isNumber(semanaNumero) &&
        semanaNumero <= 65))
  ) {
      let nuevoNombreArchivo =
        nombreArchivo.slice(0, -4) + "(" + Math.random() + ").pdf";
      const storageRef = ref(
        storage,
        `documentos/${ano}/${dni}/${nuevoNombreArchivo}`
      );
      let url = null;
      try {
        url = await new Promise((resolve, reject) => {
          const uploadTask = uploadBytesResumable(
            storageRef,
            documento,
            metadata
          );
          let timeout = setTimeout(() => {
            uploadTask.cancel();
            reject(new Error("Timeout de subida"));
          }, 60000);
          uploadTask.on(
            "state_changed",
            (snapshot) => {
              const progresoActual = Math.round(
                ((index + snapshot.bytesTransferred / snapshot.totalBytes) /
                  total) *
                  100
              );
              setProgresoGlobal(progresoActual);
            },
            (error) => {
              clearTimeout(timeout);
              reject(error);
            },
            async () => {
              clearTimeout(timeout);
              try {
                const downloadUrl = await getDownloadURL(storageRef);
                resolve(downloadUrl);
              } catch (err) {
                reject(err);
              }
            }
          );
        });
      } catch (error) {
        console.log("Error en subida:", error);
        erroVerificarNombre();
        setArchivos((prevState) => [
          ...prevState,
          {
            url: url,
            nombre: documento.name,
            registro: null,
            id: null,
          },
        ]);
        return;
      }
      let mesLetras = periodo(mesArchivo);
      let tipo = tipoDocumento(tipoDoc);
      let titulo = tipo + " " + mesLetras + " " + ano;
      if (semana) {
        titulo += " " + semana;
      }
      const infoDocumento = {
        activo: true,
        ano: ano,
        contador: 0,
        fechaDoc: serverTimestamp(),
        fechaVista: "",
        dni: dni,  // Mantiene el DNI original con ceros
        link: url,
        nombre: titulo,
        periodo: mesArchivo + "",
        tipo: tipoDoc,
        ruc: empresaData.ruc,
        semana: semana || "",
      };
      let uid = null;
      try {
        uid = await añadirDocumento(infoDocumento);
        console.log("UID generado por Firestore:", uid);
      } catch (error) {
        console.log("Error al guardar en Firestore:", error);
        setArchivos((prevState) => [
          ...prevState,
          {
            url: url,
            nombre: documento.name,
            registro: null,
            id: null,
          },
        ]);
        return;
      }
      if (uid && uid.length === 20) {
        await datosColaborador(dni, mesArchivo, ano, empresaData, semana);
        const archivoObj = {
          ...infoDocumento,
          url: url,
          nombre: documento.name,
          registro: uid,
          id: uid,
          baseDatos: "document",
          tipo: tipoDoc,
          origen: "masivo",
        };
        console.log("Objeto que se agrega a archivos:", archivoObj);
        setArchivos((prevState) => [
          ...prevState,
          archivoObj,
        ]);
      } else {
        console.log("UID inválido:", uid);
        setArchivos((prevState) => [
          ...prevState,
          {
            url: url,
            nombre: documento.name,
            registro: null,
            id: null,
          },
        ]);
      }
    } else {
      console.log("Validación fallida para archivo:", documento.name);
      console.log("DNI:", dni, "Válido:", isValidDNI(dni));
      console.log("Año:", ano, "Válido:", isNumber(parseInt(ano)) && ano > 2020);
      console.log("Mes:", mesArchivo, "Válido:", isNumber(parseInt(mesArchivo)) && mesArchivo <= 12);
      erroVerificarNombre();
      setArchivos((prevState) => [
        ...prevState,
        {
          url: null,
          nombre: documento.name,
          registro: null,
          id: null,
        },
      ]);
    }
    setProgresoGlobal(Math.round(((index + 1) / total) * 100));
  }
  


  // Procesa archivos en lotes de tamaño batchSize
  async function subirDocumentosEnLotes(batchSize = 5, empresaData) {
    setArchivos([]);
    setProgresoGlobal(0);
    const total = documentos.length;
    let index = 0;
    while (index < total) {
      const lote = documentos.slice(index, index + batchSize);
      // Procesa el lote en paralelo
      await Promise.all(
        lote.map((doc, i) =>
          procesarDocumento(doc, index + i, total, empresaData)
        )
      );
      index += batchSize;
    }
    setProgresoGlobal(100);
    
    // AUDITORÍA
    try {
      await logBusinessAction("CARGA_MASIVA_DOCUMENTOS", "GestionDocumental", {
        tipoDocumento: tipoDoc,
        periodicidad: periodicidad,
        mes: mes,
        totalProcesados: total
      }, usuario);
    } catch (e) {
      console.warn("No se pudo registrar la auditoría de carga masiva", e);
    }

    finalizarProceso();
    setIsDisabledButton(false);
  }

  async function datosColaborador(dni, mesN, anoN, empresaData, semN) {
    const notificacionesHabilitadas = empresaData.notificaciones === true;
    const q = query(collection(db, "users"), where("dni", "==", dni));
    const querySnapshot = await getDocs(q);
    let obj;
    querySnapshot.forEach((doc) => {
      obj = doc.data();
      obj.id = doc.id;
    });
    if (obj != null) {
      let td = tipoDocumento(tipoDoc);
      let mesLetras = periodo(mesN);
      let primerNombre = obj.name.split(" ")[0];
      let textNotificacion = `${primerNombre}, tu ${td.toLowerCase()} del periodo ${mesLetras} ${anoN}${
        semN ? " " + semN : ""
      } ya está disponible.`;
      const notificacion = {
        dni: dni,
        agentId: "comunication-agent",
        data: {
          isUser: false,
          read: false,
          text: textNotificacion,
        },
      };
      if (notificacionesHabilitadas) {
        try {
          await sendNotificationBatch([notificacion]);
        } catch (error) {}
      }
      let body = `<p><b>Estimado(a) ${obj.name} ${obj.apellidos},</b></p>
<p>Te hacemos entrega de tu <b>Boleta de Pago</b> correspondiente al período <b>${mesN}/${anoN}${
        semN ? " " + semN : ""
      }</b>, conforme a lo establecido por el <b>Decreto Supremo N.º 001-98-TR</b>, el <b>D.S. N.º 009-2011-TR</b> y el <b>Decreto Legislativo N.º 1310</b>.</p>
<p><b>Recomendamos visualizar tu documento desde la aplicación móvil <i>Mi Boleta</i>, disponible en:</b></p>
<ul>
  <li><a href="https://play.google.com/store/apps/details?id=pe.perubi.miboleta"><b>Google Play (Android)</b></a></li>
  <li><a href="https://apps.apple.com/us/app/mi-boleta/id6504302634"><b>App Store (iPhone)</b></a></li>
</ul>
<p>La aplicación ofrece acceso completo, seguro y una experiencia optimizada para consultar tus boletas y otros documentos laborales.</p>
<p><b>Opcionalmente</b>, puedes acceder a través de la versión web con funcionalidades limitadas. Solo debes ingresar tu correo electrónico y, como contraseña, tu número de DNI:</p>
<p><a href="https://miboleta.net.pe/app/"><b>Accede aquí a Mi Boleta Web</b></a></p>
<p><b>Importante:</b></p>
<ul>
  <li>Asegúrate de contar con la versión más reciente de la aplicación para garantizar una correcta visualización.</li>
  <li>Si tienes problemas para acceder, te sugerimos cerrar sesión e iniciar nuevamente.</li>
</ul>
<p>Si tienes alguna duda adicional, por favor comunícate con el Área de Recursos Humanos de tu empresa.</p>
<p>Atentamente,</p>
<p><b>${empresaData.name}</b></p>
<p style="font-size: 0.9em; color: gray;"><i>*Este mensaje ha sido enviado automáticamente. Te agradeceremos no responder a este correo. Para consultas personalizadas, comunícate con el Área de Recursos Humanos.</i></p>`;
      let correo = `${obj.email}`;
      let cc = ``;
      let bcc = `miboleta@perubi.com`;
      let asunto = `${empresaData.name} - ${td} - ${mesN}/${anoN}${
        semN ? " " + semN : ""
      }`;
      if (
        empresaData.coleccionEmail &&
        empresaData.coleccionEmail.trim() !== ""
      ) {
        sendCustomEmail(
          correo,
          cc,
          bcc,
          asunto,
          body,
          empresaData.coleccionEmail
        );
      } else {
        console.error(
          "coleccionEmail está vacío. No se puede enviar el correo."
        );
      }
    }
  }

  const handleUpload = () => {
    setIsDisabledButton(true);
    if (
      tipoDoc !== "DEFAULT" &&
      periodicidad !== "DEFAULT" &&
      (mes !== "DEFAULT" || mes === null)
    ) {
      if (documentos.length > 0) {
        // Pasa los datos de empresa actuales
        subirDocumentosEnLotes(5, empresa);
      } else {
        Swal.fire({
          icon: "error",
          title: "Por favor elige los archivo a enviar",
          showConfirmButton: false,
          timer: 2000,
        });
        setIsDisabledButton(false);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Por favor elige tipo de documento y frecuencia",
        showConfirmButton: false,
        timer: 4000,
      });
      setIsDisabledButton(false);
    }
  };

  return (
    <div
      className="min-vh-100"
      style={{
        background: "linear-gradient(135deg, #ffffff 0%, #ffffff 100%)",
        minHeight: "100vh",
        width: "100vw",
        maxWidth: "100%",
        padding: "20px 0",
      }}
    >
      <Container fluid style={{ width: "90%", maxWidth: "100%" }}>
        {/* Marco principal */}
        <Card
          className="shadow-lg border-0"
          style={{
            borderRadius: "15px",
            overflow: "hidden",
            minHeight: "90vh",
          }}
        >
          {/* Header Premium con degradado verde oscuro para Gestión de Documentos */}
          <Card.Header
            className="text-white py-4 position-relative"
            style={{
              background: "linear-gradient(135deg, #0d4f3c 0%, #2c7a2c 100%)",
              borderBottom: "3px solid #f39c12",
            }}
          >
            <div className="position-absolute end-0 top-50 translate-middle-y me-4" style={{ zIndex: 10 }}>
              <BotonManualHeader usuario={usuario} />
            </div>
            <div className="text-center">
              <h2 className="fw-bold mb-1">
                <FaCloudUploadAlt className="me-3" />
                Carga Masiva de Documentos
              </h2>
              <p className="mb-0 opacity-75">
                Procesa múltiples documentos de forma automática y eficiente
              </p>
            </div>
          </Card.Header>

          <Card.Body className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
            {/* Barra superior con acciones */}
            <Card className="shadow-sm border-0 mb-4" style={{ borderRadius: "15px" }}>
              <Card.Body className="p-4">
                <Row className="align-items-center">
                  <Col md={1}>
                    <div
                      className="rounded-3 p-3 text-center"
                      style={{
                        background: "linear-gradient(135deg, #0d4f3c 0%, #2c7a2c 100%)",
                        color: "white"
                      }}
                    >
                      <FaCloudUploadAlt size={24} />
                    </div>
                  </Col>
                  <Col md={11}>
                    <h5 className="mb-1 fw-semibold">Carga Masiva de Documentos</h5>
                    <p className="text-muted mb-0 small">
                      Sube y procesa documentos en lotes para múltiples trabajadores de forma automática
                    </p>
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            {/* Progreso de carga */}
            {isDisabledButton && (
              <Card className="shadow-sm border-0 mb-4" style={{ borderRadius: "15px" }}>
                <Card.Body className="p-4">
                  <div className="text-center">
                    <div
                      className="rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                      style={{
                        width: "60px",
                        height: "60px",
                        background: "linear-gradient(135deg, #0d4f3c 0%, #2c7a2c 100%)",
                        color: "white"
                      }}
                    >
                      <Spinner animation="border" variant="light" />
                    </div>
                    <h5 className="mb-2">Procesando documentos...</h5>
                    <p className="text-muted mb-3">Por favor espera mientras procesamos los archivos</p>
                    <ProgressBar
                      now={progresoGlobal}
                      label={`${progresoGlobal}%`}
                      style={{ height: "24px" }}
                      animated
                      striped
                    />
                  </div>
                </Card.Body>
              </Card>
            )}

            {/* Configuración de documentos */}
            <Card className="shadow-sm border-0 mb-4" style={{ borderRadius: "15px" }}>
              <Card.Header 
                className="text-white py-3"
                style={{ 
                  background: "linear-gradient(135deg, #0d4f3c 0%, #2c7a2c 100%)",
                  borderRadius: "15px 15px 0 0"
                }}
              >
                <div className="d-flex align-items-center">
                  <FaFileAlt className="me-2" />
                  <div>
                    <h5 className="mb-0 fw-semibold">Configuración de Documentos</h5>
                    <small className="opacity-75">Define el tipo y frecuencia de los documentos a procesar</small>
                  </div>
                </div>
              </Card.Header>
              <Card.Body className="p-4">
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label className="fw-bold">Tipo de Documento</Form.Label>
                      <Form.Select
                        onChange={selectChange}
                        value={tipoDoc}
                        className="form-control-lg"
                        style={{ borderRadius: "10px" }}
                      >
                        <option value="DEFAULT" disabled>
                          Seleccione el tipo de documento
                        </option>
                        <option value="Boletas de pago">Boletas de Pago</option>
                        <option value="CTS">CTS</option>
                        <option value="Contratos">Contratos</option>
                        <option value="Renta">Renta de 5ta</option>
                        <option value="Memorandums">Memorándums</option>
                        <option value="Utilidades">Utilidades</option>
                        <option value="Gratificaciones">Gratificaciones</option>
                        <option value="Vacaciones">Vacaciones</option>
                        <option value="Prestamos">Préstamos</option>
                        <option value="Adelantos">Adelantos</option>
                        <option value="PoliticasLaborales">Política Salarial</option>
                        <option value="Ceses">CESES Y LIQUIDACIONES</option>
                        <option value="Otros">Otros</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    {tipoDoc !== "DEFAULT" && (
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">Frecuencia del Documento</Form.Label>
                        <Form.Select
                          id="periodicidad"
                          value={periodicidad}
                          onChange={handlePeriodoChange}
                          className="form-control-lg"
                          style={{ borderRadius: "10px" }}
                        >
                          <option value="DEFAULT" disabled>
                            Seleccione la frecuencia
                          </option>
                          <option value="mensual">Mensual</option>
                          <option value="semanal">Semanal</option>
                        </Form.Select>
                      </Form.Group>
                    )}
                  </Col>
                </Row>
                {periodicidad === "semanal" && (
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-0">
                        <Form.Label className="fw-bold">Mes de referencia</Form.Label>
                        <Form.Select
                          id="mes"
                          value={mes}
                          onChange={handleMesChange}
                          className="form-control-lg"
                          style={{ borderRadius: "10px" }}
                        >
                          <option value="DEFAULT" disabled>
                            Seleccione el mes
                          </option>
                          <option value="01">Enero</option>
                          <option value="02">Febrero</option>
                          <option value="03">Marzo</option>
                          <option value="04">Abril</option>
                          <option value="05">Mayo</option>
                          <option value="06">Junio</option>
                          <option value="07">Julio</option>
                          <option value="08">Agosto</option>
                          <option value="09">Septiembre</option>
                          <option value="10">Octubre</option>
                          <option value="11">Noviembre</option>
                          <option value="12">Diciembre</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
                )}
              </Card.Body>
            </Card>

            {/* Área de carga de archivos */}
            <Card className="border-0 shadow-sm mb-4" style={{ borderRadius: "15px" }}>
              <Card.Header 
                className="text-white py-3"
                style={{ 
                  background: "linear-gradient(135deg, #0d4f3c 0%, #2c7a2c 100%)",
                  borderRadius: "15px 15px 0 0"
                }}
              >
                <div className="d-flex align-items-center">
                  <FaUpload className="me-2" />
                  <div>
                    <h5 className="mb-0 fw-semibold">Selección de Archivos</h5>
                    <small className="opacity-75">Arrastra archivos PDF o selecciona desde tu dispositivo</small>
                  </div>
                </div>
              </Card.Header>
              <Card.Body className="p-4">
                <Row className="align-items-center">
                  <Col md={8}>
                    <Form.Control
                      type="file"
                      onChange={handleChange}
                      multiple
                      accept=".pdf"
                      className="form-control-lg"
                      style={{ borderRadius: "10px" }}
                    />
                    {documentos.length > 0 && (
                      <small className="text-muted mt-2 d-block">
                        {documentos.length} archivo(s) seleccionado(s)
                      </small>
                    )}
                  </Col>
                  <Col md={4} className="text-end">
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip>Procesar documentos seleccionados</Tooltip>}
                    >
                      <Button
                        variant="primary"
                        onClick={handleUpload}
                        disabled={isDisabledButton}
                        className="btn-lg d-flex align-items-center gap-2"
                        style={{
                          borderRadius: "10px",
                          background: "linear-gradient(135deg, #0d4f3c 0%, #2c7a2c 100%)",
                          border: "none",
                        }}
                      >
                        <FaUpload />
                        {isDisabledButton ? "Procesando..." : "Procesar Documentos"}
                      </Button>
                    </OverlayTrigger>
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            {/* Estadísticas de procesamiento */}
            {archivos.length > 0 && (
              <Row className="mb-4">
                <Col md={4}>
                  <Card className="border-0 shadow-sm" style={{ borderRadius: "15px" }}>
                    <Card.Body className="text-center" style={{ background: "linear-gradient(135deg, #1e7e34 0%, #20c997 100%)", color: "white", borderRadius: "15px" }}>
                      <h4 className="fw-bold">{archivos.filter(a => a.url && a.registro).length}</h4>
                      <p className="mb-0">Exitosos</p>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={4}>
                  <Card className="border-0 shadow-sm" style={{ borderRadius: "15px" }}>
                    <Card.Body className="text-center" style={{ background: "linear-gradient(135deg, #dc3545 0%, #fd7e14 100%)", color: "white", borderRadius: "15px" }}>
                      <h4 className="fw-bold">{archivos.filter(a => !a.url || !a.registro).length}</h4>
                      <p className="mb-0">Con Errores</p>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={4}>
                  <Card className="border-0 shadow-sm" style={{ borderRadius: "15px" }}>
                    <Card.Body className="text-center" style={{ background: "linear-gradient(135deg, #17a2b8 0%, #6f42c1 100%)", color: "white", borderRadius: "15px" }}>
                      <h4 className="fw-bold">{archivos.length}</h4>
                      <p className="mb-0">Total Procesados</p>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            )}

            {/* Tabla de resultados */}
            {archivos.length > 0 && (
              <Card className="border-0 shadow-sm" style={{ borderRadius: "15px" }}>
                <Card.Header 
                  className="text-white py-3"
                  style={{ 
                    background: "linear-gradient(135deg, #0d4f3c 0%, #2c7a2c 100%)",
                    borderRadius: "15px 15px 0 0"
                  }}
                >
                  <div className="d-flex align-items-center">
                    <FaChartLine className="me-2" />
                    <div className="flex-grow-1">
                      <h5 className="mb-0 fw-semibold">Resultados del Procesamiento</h5>
                      <small className="opacity-75">Detalle del estado de cada archivo procesado</small>
                    </div>
                    <Badge bg="light" text="dark" style={{ fontSize: "0.9rem" }}>
                      {archivos.length} archivos
                    </Badge>
                  </div>
                </Card.Header>
                <Card.Body className="p-0">
                  <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    <Table responsive hover className="mb-0" style={{ fontSize: "0.9rem" }}>
                      <thead 
                        style={{
                          backgroundColor: "#f8f9fa",
                          position: "sticky",
                          top: 0,
                          zIndex: 10,
                        }}
                      >
                        <tr>
                          <th className="border-0 py-3 px-3 text-secondary fw-semibold text-center" style={{ width: '8%' }}>
                            N°
                          </th>
                          <th className="border-0 py-3 px-3 text-secondary fw-semibold" style={{ width: '40%' }}>
                            Archivo
                          </th>
                          <th className="border-0 py-3 px-3 text-secondary fw-semibold text-center" style={{ width: '13%' }}>
                            Vista
                          </th>
                          <th className="border-0 py-3 px-3 text-secondary fw-semibold text-center" style={{ width: '13%' }}>
                            Estado
                          </th>
                          <th className="border-0 py-3 px-3 text-secondary fw-semibold text-center" style={{ width: '13%' }}>
                            Registro
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {archivos.map((archivo, index) => (
                          <tr key={index} style={{ borderBottom: "1px solid #f1f3f4" }}>
                            <td className="text-center py-3 px-3">
                              <Badge bg="dark" className="px-2 py-1">
                                {index + 1}
                              </Badge>
                            </td>
                            <td className="py-3 px-3">
                              <div className="d-flex align-items-center">
                                <div 
                                  className="rounded-circle me-3 d-flex align-items-center justify-content-center"
                                  style={{
                                    width: "35px",
                                    height: "35px",
                                    background: archivo.url && archivo.registro ? 
                                      "linear-gradient(135deg, #1e7e34 0%, #20c997 100%)" : 
                                      "linear-gradient(135deg, #dc3545 0%, #fd7e14 100%)",
                                    color: "white"
                                  }}
                                >
                                  <FaFileAlt size="14px" />
                                </div>
                                <div>
                                  <div className="fw-medium text-dark small">
                                    {archivo.nombre.length > 40 
                                      ? archivo.nombre.substr(0, 40) + "..." 
                                      : archivo.nombre}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td className="text-center py-3 px-3">
                              <OverlayTrigger
                                placement="top"
                                overlay={<Tooltip>{archivo.url ? "Ver documento" : "No disponible"}</Tooltip>}
                              >
                                <a
                                  href={archivo.url}
                                  target="_blank"
                                  rel="noreferrer"
                                  style={{ textDecoration: 'none' }}
                                >
                                  {archivo.url === null ? (
                                    <MdVisibilityOff className="text-danger" size="20px" />
                                  ) : (
                                    <MdVisibility className="text-primary" size="20px" />
                                  )}
                                </a>
                              </OverlayTrigger>
                            </td>
                            <td className="text-center py-3 px-3">
                              {archivo.url === null ? (
                                <BsFillXCircleFill className="text-danger" size="20px" />
                              ) : (
                                <BsCheckCircleFill className="text-success" size="20px" />
                              )}
                            </td>
                            <td className="text-center py-3 px-3">
                              {archivo.registro === null ? (
                                <TbDatabaseOff className="text-danger" size="20px" />
                              ) : (
                                <TbDatabase className="text-success" size="20px" />
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </Card.Body>
              </Card>
            )}
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default Masivos;